import { $GET, $POST } from '@/api/gateway/gatewayMethods';
import { AuthAccount, Signout, SwitchSite, GetSessionUserSiteInfo } from '@/api/endpoint-defines/account';

export const authAccount = ({ BodyData }) => $POST({ EndPoint: AuthAccount, BodyData });
export const signout = ({ BodyData = null }) => $POST({ EndPoint: Signout, BodyData });
export const switchSiteAPI = ({ BodyData }) => $POST({ EndPoint: SwitchSite, BodyData });
export const getSessionUserSiteInfoAPI = () => $GET({ EndPoint: GetSessionUserSiteInfo, QueryParameters: null });